import { useQuery } from "@apollo/react-hooks";
import { useMachineTranslation, useTranslation } from "@outschool/localization";
import { pathFromLocation } from "@outschool/routes";
import { useSession } from "@outschool/ui-auth";
import { useTopNoticeContext } from "@outschool/ui-components-website";
import { Banner } from "@outschool/ui-legacy-component-library";
import gql from "graphql-tag";
import React from "react";
import { Trans } from "react-i18next";
import { useLocation } from "react-router-dom";

import { ActivityFragment } from "../../shared/client/fragments/ActivityFragments";
import * as Routes from "../../shared/Routes";
import { SectionFragment } from "../queries/SectionFragments";
import Link from "./Link";

export const REVIEW_REMINDER_QUERY_NAME = "ReviewReminderTopNoticeBar";

export const reviewReminderQuery = gql`
  query ReviewReminderTopNoticeBar {
    currentUser {
      uid
      enrolledSectionThatNeedsReview {
        filledSpaceCount
        ...SectionFragment
        activity {
          ...ActivityFragment
        }
      }
    }
  }
  ${SectionFragment}
  ${ActivityFragment}
`;

export default function ReviewReminderTopNoticeBar() {
  const { topNotice, timedTopNotice } = useTopNoticeContext();
  const hide = !!topNotice || timedTopNotice;
  const { currentUser } = useSession();
  const location = useLocation();
  const { loading, error, data } = useQuery(reviewReminderQuery, {
    skip: !!hide || !currentUser
  });
  const { t } = useTranslation(
    "client\\components\\ReviewReminderTopNoticeBar"
  );

  const { translate } = useMachineTranslation();

  if (hide || !currentUser) {
    return null;
  }
  if (loading || error) {
    return null;
  }
  const { enrolledSectionThatNeedsReview: section = null } =
    (data && data.currentUser) || {};
  if (!section) {
    return null;
  }
  const { activity } = section;
  const feedbackPath = Routes.sectionFeedbackPath(activity, section);
  if (pathFromLocation(location) === feedbackPath) {
    return null;
  }

  const activityTitle = translate(activity.title);
  return (
    <Banner>
      <Trans t={t}>
        Please <Link to={feedbackPath}>give feedback</Link> for '
        {{ activityTitle }}'
      </Trans>
    </Banner>
  );
}
